import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaShieldAlt } from '@react-icons/all-files/fa/FaShieldAlt';
import { FaTasks } from '@react-icons/all-files/fa/FaTasks';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaSitemap } from '@react-icons/all-files/fa/FaSitemap';
import Breadcrumb from '../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../commons/TileContainer';
import PerfilesSistemaPage from '../usuarios/perfiles-sistema-page';
import PerfilesSistemaFormPage from '../usuarios/perfiles-sistema-form-page';
import SysTasksPage from './sys-tasks-page';
import SysTasksFormPage from './sys-tasks-form-page';
import AppRoutesDirectory from '../../../routing/AppRoutesDirectory';

const SEGURIDAD = '/configuracion/seguridad';

const tiles: TileItem[] = [
  { key: 'perfiles-sistema', label: 'Perfiles de Sistema', icon: <FaShieldAlt />, color: '#6366f1' },
  { key: 'sys-tasks', label: 'Tareas de Sistema', icon: <FaTasks />, color: '#0d9488' },
  { key: 'mapa-rutas', label: 'Mapa de rutas', icon: <FaSitemap />, color: '#7c3aed' },
];

function SeguridadIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb
        items={[
          { label: 'Inicio', to: '/', icon: <FaHome /> },
          { label: 'Configuración', to: '/configuracion', icon: <FaCog /> },
          { label: 'Seguridad', icon: <FaShieldAlt /> },
        ]}
      />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#475569' }}>
          <FaShieldAlt style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Seguridad</h2>
          <p style={s.subtitle}>Gestión de roles, permisos y políticas del sistema</p>
        </div>
      </div>

      <TileContainer tiles={tiles} onSelect={key => navigate(`${SEGURIDAD}/${key}`)} />
    </div>
  );
}

export default function SeguridadConfigPage() {
  return (
    <Routes>
      <Route path="/mapa-rutas" element={<AppRoutesDirectory />} />
      <Route path="/sys-tasks/new" element={<SysTasksFormPage />} />
      <Route path="/sys-tasks/:id/edit" element={<SysTasksFormPage />} />
      <Route path="/sys-tasks" element={<SysTasksPage />} />
      <Route path="/perfiles-sistema/new" element={<PerfilesSistemaFormPage />} />
      <Route path="/perfiles-sistema/:id/edit" element={<PerfilesSistemaFormPage />} />
      <Route path="/perfiles-sistema" element={<PerfilesSistemaPage />} />
      <Route path="/" element={<SeguridadIndex />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page: { display: 'flex', flexDirection: 'column', gap: 28 },
  header: { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon: { fontSize: 22, color: '#fff', display: 'flex' },
  title: { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle: { margin: 0, fontSize: 13, color: '#64748b' },
};
